import { ScoutingGoalkeepersPage } from "@/pages/scouting/goalkeepers/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/scouting/goalkeepers")({
    component: ScoutingGoalkeepersPage,
});
